var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 140 140"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M140 112.5A27.48 27.48 0 0 0 93.17 93a2.51 2.51 0 0 1-2.88.46L56.1 76.33a2.51 2.51 0 0 1-1.36-2.58 26.92 26.92 0 0 0 0-7.5 2.51 2.51 0 0 1 1.36-2.58l34.19-17.09a2.49 2.49 0 0 1 2.88.46 27.51 27.51 0 1 0-8-16.51 2.5 2.5 0 0 1-1.37 2.52L49.14 50.38a2.49 2.49 0 0 1-2.83-.38 27.5 27.5 0 1 0 0 40 2.51 2.51 0 0 1 2.83-.42L83.8 107a2.49 2.49 0 0 1 1.37 2.51 27.5 27.5 0 1 0 54.83 3z",
  stroke: "none"
})));
export default SvgShare;